import { DepositMethodsEnum } from './../../../enums/deposit-methods.enum';
import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { DialogDepositComponent } from '../../dialog-deposit/dialog-deposit.component';
import { PixDepositService } from '../../../services/pix-deposit/pix-deposit.service';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';
import { isCnpj } from '@toro/common/shared/helpers/utils/document';

enum PixButtonState {
  Loading,
  Visible,
  Hidden
}

@Component({
  selector: 'active-account-transfer',
  templateUrl: './active-account-transfer.component.html',
  styleUrls: ['./active-account-transfer.component.scss']
})
export class ActiveAccountTransferComponent {
  @Input() userAuth: any;
  @Input() user: any;
  pixButtonState: PixButtonState;
  public isNewBrand: boolean = environment.isNewBrand

  constructor(
    private pixDepositService: PixDepositService,
    private dialogsService: DialogsService,
    private store: Store<any>
  ) {
    this.pixButtonState = PixButtonState.Loading;
    this.checkPixEnabled();
  }

  public openDepositModal(depositCategory: string) {
    this.dialogsService.showComponentAsAsidePanel(
      DialogDepositComponent,
      true,
      {
        category: depositCategory,
        user: this.user,
        userAuth: this.userAuth
      }
    );

    if (depositCategory === DepositMethodsEnum.Pix) {
      const events = {
        'Product Area Origin': 'Depósito',
        'Time Responsável': 'Roebling',
        Element: 'Botão depósito via Pix',
        Text: 'Depósito via Pix Copia e Cola'
      };
      this.sendTracking('Element Clicked', events);
    } else if (depositCategory === DepositMethodsEnum.Ted) {
      const events = {
        'Product Area Origin': 'Depósito',
        'Time Responsável': 'Roebling',
        Element: 'Botão depósito via TED',
        Text: 'Depósito via TED'
      };
      this.sendTracking('Element Clicked', events);
    }
  }

  public showUserAccount() {
    if (!this.user || !this.userAuth) return false;

    return this.user.user.cpfcnpj && this.userAuth.currentUser.cblc;
  }

  /**
   * Indica se a conta logada e Pessoa Juridica (documento com mais de 11 digitos = CNPJ)
   */
  public get isPj(): boolean {
    return isCnpj(this.user && this.user.user && this.user.user.cpfcnpj);
  }

  public checkPixEnabled() {
    this.pixDepositService
      .getDepositByPixEnabled()
      .then(remoteConfigValue => {
        this.pixButtonState = remoteConfigValue
          ? PixButtonState.Visible
          : PixButtonState.Hidden;
      })
      .catch(err => {
        console.error(err);
        this.pixButtonState = PixButtonState.Hidden;
      });
  }

  public isPixLoading() {
    return this.pixButtonState == PixButtonState.Loading;
  }

  public isPixVisible() {
    return this.pixButtonState == PixButtonState.Visible && !this.isPj;
  }

  public isPixEnabled() {
    return this.isPixVisible() && this.showUserAccount();
  }

  public sendTracking(event: string, breakdowns: any) {
    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: { type: event, events: breakdowns }
    });
  }
}
